<template>
  <q-layout
    view="lHh lpr lFr"
  >
    <main-loader />

    <drawer-swap-content />

    <q-page-container>
      <transition
        :duration="50"
        appear
        mode="out-in"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <router-view />
      </transition>
    </q-page-container>
  </q-layout>
</template>

<script>
import { Notify } from 'quasar';
import MainLoader from '@/components/MainLoader';
import DrawerSwapContent from '@/components/DrawerSwapContent';

export default {
  name: 'LayoutDefault',
  components: { DrawerSwapContent, MainLoader },
  data: () => ({
    key: '',
  }),
  async mounted() {
    // Updates logged user after every page refresh (it avoids user becoming outdated after groups/permissions updates)
    const user = await this.$services.accounts.getLoggedUser();
    if (!user) return;
    localStorage.setItem('acl', JSON.stringify(user));
  },
  created() {
    this.$g.notification.main.on(this.handleNotifyEvents);
  },
  destroyed() {
    this.$g.notification.main.on(this.handleNotifyEvents);
  },
  methods: {
    handleNotifyEvents(action) {
      const types = {
        SHOW: () => {
          const isText = !(typeof action.payload === 'object');
          const payload = isText
            ? { message: action.payload }
            : action.payload;

          Notify.create(payload);
        },
        HIDE: () => {},
      };

      return types[action.type] && types[action.type]();
    },
  },
};
</script>
